module.exports = __webpack_public_path__ + "img/second-block-bg-mobile.5e9ffb84.jpg";